/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PersonalAssetHistoryInputTypeEnum {
    Transaction = 'transaction',
    Balance = 'balance'
}

export function PersonalAssetHistoryInputTypeEnumFromJSON(json: any): PersonalAssetHistoryInputTypeEnum {
    return PersonalAssetHistoryInputTypeEnumFromJSONTyped(json, false);
}

export function PersonalAssetHistoryInputTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetHistoryInputTypeEnum {
    return json as PersonalAssetHistoryInputTypeEnum;
}

export function PersonalAssetHistoryInputTypeEnumToJSON(value?: PersonalAssetHistoryInputTypeEnum | null): any {
    return value as any;
}

